import React, { useEffect, useState } from "react";

// MODULES

// HOOKS
import { useNavigate } from "react-router-dom";
import { useResizeDetector } from "react-resize-detector";

// ICONS + IMAGES
import ihrLogo from "../../../static/img/IHR-by-Bodymatter_Logo_Black.png";
import { HamburgerMenuIcon, CloseIcon } from "../../ui/iconify/icons";

// STYLES
import "./AppNavBar.scss";
import IconButton from "../../ui/buttons/IconButton/IconButton";
import { useAuthContext } from "../../../hooks/context/AuthContext";

// COMPONENTS
// src/components/NavBar/NavBar.tsx
interface IAppNavBarProps {
    className?: string;
}

// TODO create enum for active route
// const location = useLocation();
// const [activeRoute, setActiveRoute] = useState<
//     "dashboard" | "reports" | "other"
// >("other");
// useEffect(() => {
//     if (location.pathname.startsWith("/dashboard")) {
//         setActiveRoute("dashboard");
//     } else if (location.pathname.startsWith("/reports")) {
//         setActiveRoute("reports");
//     } else {
//         setActiveRoute("other");
//     }
// }, [location.pathname]);

const AppNavBar: React.FC<IAppNavBarProps> = ({ className = "" }) => {
    const navigate = useNavigate();

    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
    const { logout } = useAuthContext();
    const { width, ref } = useResizeDetector();

    useEffect(() => {
        if (width && width >= 600) {
            // If this width changes the nav resize variable ($nav-bar-mobile-collapse-width) needs to change accordingly
            setIsMobileMenuOpen(false);
        }
    }, [width]);

    const handleNav = (path: string) => {
        setIsMobileMenuOpen(false);
        navigate(path);
    };

    return (
        <div className={`AppNavBar ${className}`} ref={ref}>
            <div className="AppNavBar__logo">
                <button
                    className="AppNavBar__logo-button"
                    onClick={() => handleNav("/dashboard")}
                    aria-label="Go to Account"
                >
                    <img src={ihrLogo} alt="IHR by BodyMatter" />
                </button>
            </div>

            {/* DESKTOP NAV */}
            <nav className="AppNavBar__nav-desktop">
                <button onClick={() => handleNav("/dashboard")}>Account</button>
                <button onClick={() => handleNav("/reports")}>
                    Shareable Reports
                </button>
                <button className="AppNavBar__LogoutBtn" onClick={logout}>
                    Log Out
                </button>
            </nav>

            {/* MOBILE MENU TOGGLE */}
            <div className="AppNavBar__nav-mobile-toggle">
                <IconButton
                    icon={HamburgerMenuIcon}
                    onClick={() => setIsMobileMenuOpen((prev) => !prev)}
                    aria-label="Open Menu"
                    className="AppNavBar__nav-mobile-button"
                />
            </div>

            {/* MOBILE MENU NAV */}
            {isMobileMenuOpen && (
                <div className="AppNavBar__mobile-menu">
                    <IconButton
                        icon={CloseIcon}
                        onClick={() => setIsMobileMenuOpen(false)}
                        aria-label="Close Menu"
                        className="AppNavBar__mobile-menu-close AppNavBar__nav-mobile-button"
                    />
                    <button onClick={() => handleNav("/dashboard")}>
                        Account
                    </button>
                    <button onClick={() => handleNav("/reports")}>
                        Shareable Reports
                    </button>
                    <button className="AppNavBar__LogoutBtn" onClick={logout}>
                        Log Out
                    </button>
                </div>
            )}
        </div>
    );
};

export default AppNavBar;
